/**
 * Filter configuration utilities for photo filters
 */

// Filter type configurations
export const getFilterTypeConfig = (filterType) => {
  const configs = {
    airport: {
      type: 'airport',
      label: 'Airport',
      placeholder: 'Enter IATA code (e.g., OSL)',
      examples: ['OSL', 'ARN', 'CPH'],
      description: 'Search by airport IATA (3-letter) codes'
    },
    operator: {
      type: 'operator',
      label: 'Operator',
      placeholder: 'Enter airline or operator name (e.g., American Airlines, Delta)',
      examples: ['American Airlines', 'Delta', 'United', 'Southwest'],
      description: 'Search by airline or aircraft operator name'
    },
    aircraftType: {
      type: 'aircraftType',
      label: 'Aircraft Type',
      placeholder: 'Enter aircraft model (e.g., Boeing 737, A320, 737-800)',
      examples: ['Boeing 737', 'Airbus A320', '737-800', 'A380'],
      description: 'Search by aircraft manufacturer and model'
    },
    registration: {
      type: 'registration',
      label: 'Registration',
      placeholder: 'Enter tail number (e.g., N12345, G-ABCD, D-ABCD)',
      examples: ['LN-TUA', 'G-ABCD', 'D-ABCD', 'JA123A'],
      description: 'Search by aircraft registration or tail number'
    },
    category: {
      type: 'category',
      label: 'Category',
      placeholder: 'Enter photo category (e.g., Air-to-Air, Ground, Takeoff)',
      examples: ['Air-to-Air', 'Ground', 'Takeoff', 'Landing'],
      description: 'Search by photo category or type'
    }
  };
  
  return configs[filterType] || null;
};